module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eDuNA"))).then(() => parcelRequire('hEqeo'));